import React from 'react';

const ThinxLogo = ({ width = 60 }) => {
  const logoUrl = 'https://www.thinx.com/cdn/shop/files/Thinx_logo-black.svg?v=1718895277&width=352';

  return (
    <div className="thinx-logo">
      <img
        src={logoUrl}
        alt="Thinx Logo"
        width={width}
      />
    </div>
  );
};

export default ThinxLogo;
